<template>
  <v-file-input
    v-model="file"
    :loading="loading"
    :disabled="disabled"
    accept=".mp4"
    label="direct upload .mp4 to Vimeo"
  />
</template>

<script>
import Vimeo from 'vimeo';
import MD5 from 'crypto-js/md5';
import encLatin1 from 'crypto-js/enc-latin1';
import fetchErrorMixin from '../mixins/fetchErrorMixin';

export default {
  name: 'VimeoInput',
  mixins: [fetchErrorMixin],
  props: {
    sourceId: {
      type: Number,
    },

    priorityId: {
      type: Number,
    },

    isEnablePoiAfterUpload: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Vimeo: null,

    file: null,
    disabled: false,
    loading: false,
  }),

  methods: {
    async uploadVideo() {
      this.loading = true;
      this.disabled = true;
      this.$emit('loading');

      // get hash file
      const reader = new FileReader();
      reader.readAsBinaryString(this.file);
      const hash = await new Promise((resolve) => {
        reader.onload = function () {
          resolve(MD5(encLatin1.parse(reader.result)).toString());
        };
      });

      this.$requestHelpers.get('api/admin/vimeo-credentials',
        {
          params: {
            poi_id: this.$route.params.id,
          },
        })
        .then((response) => {
          const client = new Vimeo.Vimeo(
            response.data.CLIENT_ID,
            response.data.CLIENT_SECRET,
            response.data.ACCESS_TOKEN,
          );

          client.upload(
            this.file,
            { name: this.file.name },
            (uri) => {
              console.log('File upload completed. Your Vimeo URI is:', uri);

              this.$emit('complete');

              this.$requestHelpers
                .post(
                  'api/admin/videodata/processVimeo',
                  {
                    uri,
                    poiId: this.$route.params.id,
                    source_id: this.sourceId,
                    priority_id: this.priorityId,
                    is_enable_poi_after_upload: this.isEnablePoiAfterUpload,
                    hash,
                  },
                )
                .then((videodata) => {
                  this.$emit('saved', videodata.data.result);
                }).catch((error) => {
                  this.$emit('error', this.fetchError(error));
                }).finally(() => {
                  this.loading = false;
                  this.disabled = false;
                  this.file = null;
                });
            },
            (bytesUploaded, bytesTotal) => {
              console.log(bytesUploaded, bytesTotal);
            },
            (error) => {
              this.loading = false;
              this.disabled = false;
              this.file = null;

              this.$emit('error', 'error');
              console.log(`Failed because: ${error}`);
            },
          );
        })
        .catch((error) => {
          console.log(`Failed because: ${error}`);
          this.$emit('error', this.fetchError(error));
        }).finally(() => {
          this.loading = false;
          this.disabled = false;
          this.file = null;
        });
    },
    clearFile() {
      this.file = null;
    },
  },

  watch: {
    file(file) {
      if (!file) {
        this.$emit('clear');
      } else {
        this.$emit('fileselected', file);
      }
    },
  },
};
</script>
